import React, { useState, useEffect, useMemo } from "react"
import {
  Row,
  Col,
  Button,
  FormControl,
  Table,
  Spinner,
  Modal,
  Form,
} from "react-bootstrap"
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table"
import { API_WEB_URLS } from "../../constants/constAPI"
import { useDispatch } from "react-redux"
import { Fn_AddEditData, Fn_FillListData } from "../../store/Functions"
import { useNavigate } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import ReactToggle from "react-toggle"
import "react-toggle/style.css" // Import the toggle styles

const Update_AmountCollection = () => {
  const [gridData, setGridData] = useState([])
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)
  const [state, setState] = useState({
    id: 0,
    FillArray: [],
    isProgress: true,
  })
  const [formData, setFormData] = useState({
    collectionAmount: "",
    F_LedgerMaster: "",
    IsInvoiceClear: false,
  })
  const [ledgerOptions,setledgerOptions] = useState([]);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const rtPage_Add = "/AddMCQH"
  const rtPage_Edit = "/EditMCQH"
  const breadCrumbTitle = "Amount Collection Master"
  const breadcrumbItem = "Amount Collection Master"

  const API_URL = `${API_WEB_URLS.MASTER}/0/token/AmountCollection`
  const API_URL1 = `${API_WEB_URLS.MASTER}/0/token/Ledger`
    const API_URL_SAVE = "AmountCollection/0/token"


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0")
      Fn_FillListData(dispatch, setledgerOptions, "gridData", API_URL1 + "/Id/0")
      setLoading(false)
    }

    fetchData()
  }, [dispatch, API_URL])

  const btnAddOnClick = () => {
    navigate(rtPage_Add, { state: { Id: 0 } })
  }

  const btnEditOnClick = Id => {
    navigate(rtPage_Edit, { state: { Id } })
  }

  const btnCollectAmount = row => {
    setSelectedRow(row)
    setFormData({
      collectionAmount: "",
      F_LedgerMaster: "",
      IsInvoiceClear: false,
    })
    setShowModal(true)
  }

  const handleModalClose = () => {
    setShowModal(false)
    setSelectedRow(null)
  }

  const handleCollectAmountSubmit = async () => {
    if (
      !formData.collectionAmount ||
      isNaN(formData.collectionAmount) ||
      parseFloat(formData.collectionAmount) <= 0
    ) {
      alert("Please enter a valid amount.")
      return
    }

    if (!formData.F_LedgerMaster) {
      alert("Please select a ledger.")
      return
    }


    console.log("Form Data:", formData)

    
    const obj = JSON.parse(localStorage.getItem("authUser"));

    const vformData = new FormData();
    vformData.append("F_LedgerMaster", formData.F_LedgerMaster);
    vformData.append("AmountCollected", formData.collectionAmount);
    vformData.append("IsInvoiceClear", formData.IsInvoiceClear);
    vformData.append("UserId", obj.uid);
    
 
  await Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: selectedRow.Id,formData:vformData } },
        API_URL_SAVE,
        true,
        "memberid"
      );
    // Close modal after submission
    window.location.reload();
    
    setShowModal(false)
    setSelectedRow(null)

  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }))
  }

  const data = useMemo(() => gridData || [], [gridData])

  const columns = useMemo(
    () => [
      { Header: "VoucherNo", accessor: "VoucherNo" },
      { Header: "SalePerson", accessor: "SalePerson" },
      { Header: "GrossAmount", accessor: "GrossAmount" },
      { Header: "InvoiceAmount", accessor: "InvoiceAmount" },
      { Header: "AmountCollected", accessor: "AmountCollected" },
      { Header: "DueAmount", accessor: "DueAmount" },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <Button
            variant="primary"
            size="sm"
            onClick={() => btnCollectAmount(row.original)}
          >
            Collect Amount
          </Button>
        ),
      },
    ],
    []
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize, globalFilter },
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={breadCrumbTitle} breadcrumbItem={breadcrumbItem} />
        <Row className="mb-2">
          <Col md="4">
            <FormControl
              type="text"
              placeholder="Search"
              value={globalFilter || ""}
              onChange={e => setGlobalFilter(e.target.value)}
              className="mb-2"
            />
          </Col>
        </Row>

        <Table {...getTableProps()} responsive bordered striped>
          <thead>
            {headerGroups.map((headerGroup, headerGroupIndex) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    key={columnIndex}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, rowIndex) => {
              prepareRow(row)
              return (
                <tr {...row.getRowProps()} key={rowIndex}>
                  {row.cells.map((cell, cellIndex) => (
                    <td {...cell.getCellProps()} key={cellIndex}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Collect Amount</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedRow && (
              <>
                <p>
                  <strong>Voucher No:</strong> {selectedRow.VoucherNo}
                </p>
                <p>
                  <strong>Invoice Amount:</strong> {selectedRow.InvoiceAmount}
                </p>
                <p>
                  <strong>Gross Amount:</strong> {selectedRow.GrossAmount}
                </p>
                <p>
                  <strong>Due Amount:</strong> {selectedRow.DueAmount}
                </p>
                <p>
                  <strong>Sales Person:</strong> {selectedRow.SalePerson}
                </p>
                <Form.Group controlId="collectionAmount">
                  <Form.Label>Collection Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="collectionAmount"
                    placeholder="Enter amount"
                    value={formData.collectionAmount}
                    onChange={handleInputChange}
                  />
                </Form.Group>
                <Form.Group controlId="ledger">
                  <Form.Label>Select Ledger</Form.Label>
                  <Form.Control
                    as="select"
                    name="F_LedgerMaster"
                    value={formData.F_LedgerMaster}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Ledger</option>
                    {ledgerOptions.map(ledger => (
                      <option key={ledger.ID} value={ledger.ID}>
                        {ledger.Name}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
                <Form.Group controlId="invoiceClear">
                  <label style={{ display: "flex", alignItems: "center" }}>
                    <span style={{ marginRight: "10px" }}>
                      Is Invoice Clear
                    </span>
                    <ReactToggle
                      className="m-2"
                      checked={formData.IsInvoiceClear}
                      onChange={e => {
                        setFormData(prevState => ({
                          ...prevState,
                          IsInvoiceClear: e.target.checked,
                        }))
                      }}
                    />
                  </label>
                </Form.Group>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button variant="primary" onClick={handleCollectAmountSubmit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
  )
}

export default Update_AmountCollection
